import React from "react";
import { Outlet } from "react-router-dom";
import Copyright from "../components/Copyright";
import Sidebar from "../components/Sidebar";
import Header from "./Header";

const StudentLayout = () => {
  return (
    <div>
      <Header />
      <div className="flex">
        <div>
          <Sidebar />
        </div>
        <div className="h-full w-full">
          <Outlet />
        </div>
      </div>
      <Copyright />
    </div>
  );
};

export default StudentLayout;
